import { Component, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AppButtonComponent } from '../app-button/app-button.component';

declare var bootstrap: any;

@Component({
  selector: 'app-payment-options-modal',
  standalone: true,
  imports: [CommonModule, AppButtonComponent],
  templateUrl: './payment-options-modal.component.html',
  styleUrls: ['./payment-options-modal.component.scss']
})
export class PaymentOptionsModalComponent implements OnDestroy {
  selectedOption: string = '';
  @Input() options: string[] = [];
  @Input() paymentModalData: any;
  @Output() confirmActionChange = new EventEmitter<string>();

  private modalSubscription: Subscription | undefined;
  private modalInstance: any;

  confirmBtn = {
    buttonText: 'Confirmar',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
  };

  constructor(private modalService: ModalService, private router: Router) { }

  ngOnInit(): void {


    this.modalSubscription = this.modalService.modalState$.subscribe((state) => {
      if (state.id === 'modal-payment-options') {
        const modalElement = document.getElementById(state.id);
        if (modalElement) {
          if (state.action === 'open') {
            this.modalInstance = new bootstrap.Modal(modalElement);
            this.modalInstance.show();
          } 
        }
      }
    });
  }

  getSelectedOption(): string {
    const selectedOption = document.querySelector('input[name="paymentOption"]:checked') as HTMLInputElement;
    return selectedOption ? selectedOption.value : '';
  }

  onConfirm(): void {
    this.selectedOption = this.getSelectedOption();
    this.closeModal();

    if (this.selectedOption && this.selectedOption != 'Usar apenas pontos') {
      this.router.navigate(['/finalizar-resgate'], {
        queryParams: {
          experienceId: this.paymentModalData.id,
          useBalance: this.selectedOption === 'Usar pontos do saldo e dinheiro' ? 'true' : 'false'
        },
      });
    }
  }

  closeModal(): void {
    this.confirmActionChange.emit(this.selectedOption);
    const modalElement = document.getElementById('modal-payment-options');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();

      }
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }

    }

    
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }
}